module.exports = __webpack_public_path__ + "img/car3.b6cd06d6.png";